import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import SectionPage from "@/pages/SectionPage";
import Birthdays from "@/pages/Birthdays";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import StaffLogin from "@/pages/StaffLogin";
import StaffSignup from "@/pages/StaffSignup";
import StaffPortal from "@/pages/StaffPortal";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import BookWithStaff from "@/pages/BookWithStaff";
import TicketSuccess from "@/pages/TicketSuccess";
import TicketVerify from "@/pages/TicketVerify";
import TableMenu from "@/pages/TableMenu";
import RsvpPass from "@/pages/RsvpPass";
import StaffReview from "@/pages/StaffReview";
import DoorScanner from "@/pages/DoorScanner";
import TicketCancel from "@/pages/TicketCancel";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import { captureReferralFromUrl } from "@/lib/referral";

// Silently grab ?ref= off any page and stash it — this is what powers
// staff commission attribution when the customer books/buys later.
function ReferralCatcher() {
  const loc = useLocation();
  useEffect(() => {
    captureReferralFromUrl();
  }, [loc.search]);
  return null;
}

function App() {
  return (
    <div className="App font-body text-[var(--trio-text)] bg-[var(--trio-bg)] min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <ReferralCatcher />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/menu" element={<SectionPage />} />
              <Route path="/specials" element={<SectionPage />} />
              <Route path="/events" element={<SectionPage />} />
              <Route path="/gallery" element={<SectionPage />} />
              <Route path="/reviews" element={<SectionPage />} />
              <Route path="/reservations" element={<SectionPage />} />
              <Route path="/careers" element={<SectionPage />} />
              <Route path="/birthdays" element={<Birthdays />} />
              {/* Short staff QR → drops customer straight on the "book with X" landing */}
              <Route path="/r/:code" element={<BookWithStaff />} />
              <Route path="/book/:code" element={<BookWithStaff />} />
              <Route path="/tickets/success" element={<TicketSuccess />} />
              <Route path="/tickets/cancel" element={<TicketCancel />} />
              <Route path="/tickets/verify/:id" element={<TicketVerify />} />
              <Route path="/t/:code" element={<TableMenu />} />
              <Route path="/rsvp/verify/:id" element={<TicketVerify kind="rsvp" />} />
              <Route path="/rsvp/:id" element={<RsvpPass />} />
              <Route path="/review/:code" element={<StaffReview />} />
              <Route path="/door" element={<DoorScanner />} />
              <Route path="/staff/login" element={<StaffLogin />} />
              <Route path="/staff/signup" element={<StaffSignup />} />
              <Route path="/staff" element={<StaffPortal />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/staff/forgot-password" element={<ForgotPassword />} />
              <Route path="/admin/forgot-password" element={<ForgotPassword />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
